export const CREATE_INVOICE_CODES_MUTATION = `
  mutation CreateInvoiceCodes($object: invoice_codes_insert_input!) {
    insert_invoice_codes_one(object: $object) {
      id
      code_name
      product_name
      description
      company_id
      created_at
    }
  }
`;

export const UPDATE_INVOICE_CODES_MUTATION = `
  mutation UpdateInvoiceCodes($id: Int!, $set: invoice_codes_set_input!) {
    update_invoice_codes_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      code_name
      product_name
      description
      company_id
      created_at
    }
  } 
`;

export const DELETE_INVOICE_CODES_MUTATION = `
  mutation DeleteInvoiceCodes($id: Int!) {
    delete_invoice_codes_by_pk(id: $id) {
      id
    }
  }
`; 